import React from 'react'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import {
  REQUEST_MENUS,
  REQUEST_DEBIT_CARD_MENUS,
  ACCOUNT_SUB_MENUS,
} from '../../../layout/Layout/menu-names'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { useTranslation } from 'react-i18next'

import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import { getMenuListSelector } from '../../../selectors'
import { useSelector } from 'react-redux'
import MenuCard from '../../../layout/Navigation/menu-card'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'

//const menuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'OTHER_SERVICES')[0].children
const subMenuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'REQUESTS')[0].children[2].children

export default function DebitCard() {
  const history = useHistory()
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['DEBIT_CARD'] || {}

  return (
    <LayoutWithOutAccountCard breadCumKey='DEBIT_CARD' showEmptySpace={true} keyPath={'DEBIT_CARD'}>
      <Row>
        {Object.keys(menuConfig).length > 0 &&
          subMenuDetails.map((option, index) => (
            <>
              {menuConfig[option.key] && (
                <MenuCard
                  handleMenuCallback={() => history.push(option.link)}
                  icon={option.icon}
                  name={option.title}
                  description={option.desc}
                  key={index}
                />
              )}
            </>
          ))}
      </Row>
    </LayoutWithOutAccountCard>
  )
}
